import {RefObject, useState} from 'react';
import * as React from 'react';

import {
  useFetchArtifactCollectionTriggersQuery,
  useFetchProjectTriggersQuery,
} from '../../../../generated/graphql';
import {trackCreateTriggerClicked} from '../../../../util/navigation';
import {CreateTriggerModal} from '../../../ArtifactCollectionSettings/CreateTriggerModal';
import {Button} from '../../../Button';
import {TriggerTable} from '../../../Launch/Triggers/TriggersTab';
import * as S from './style';

type TriggersOverviewTableProps = {
  entityName: string;
  projectName: string;
  projectID: string;
  collectionID: string;
  inputRef: RefObject<HTMLDivElement> | null;
};

export const TriggersOverviewTable = ({
  projectName,
  entityName,
  projectID,
  collectionID,
  inputRef,
}: TriggersOverviewTableProps) => {
  const [addTriggerModalOpen, setAddTriggerModalOpen] = useState(false);
  const projectTriggersQuery = useFetchProjectTriggersQuery({
    variables: {
      projectName,
      entityName,
    },
  });
  const collectionTriggersQuery = useFetchArtifactCollectionTriggersQuery({
    variables: {
      artifactCollectionID: collectionID,
    },
  });
  const projectScopedTriggers =
    projectTriggersQuery?.data?.project?.triggers.filter(
      t => t.scope.__typename === 'Project'
    ) ?? [];
  const acScopedTriggers =
    collectionTriggersQuery?.data?.artifactCollection?.triggers.edges.map(
      t => t?.node
    ) ?? [];
  const triggers = [...acScopedTriggers, ...projectScopedTriggers];

  if (
    projectTriggersQuery.loading ||
    !projectTriggersQuery.data ||
    collectionTriggersQuery.loading ||
    !collectionTriggersQuery.data
  ) {
    return null;
  }

  return (
    <>
      {triggers!.length > 0 ? (
        <div ref={inputRef}>
          <S.OverviewPanelSectionHeader>
            <S.OverviewPanelSectionHeaderTitle>
              Automations
            </S.OverviewPanelSectionHeaderTitle>
            <S.TriggerContainer>
              <Button
                icon="add-new"
                size="medium"
                variant="primary"
                onClick={() => {
                  setAddTriggerModalOpen(true);
                  trackCreateTriggerClicked(
                    'Model registry trigger table header'
                  );
                }}>
                New automation
              </Button>
            </S.TriggerContainer>
          </S.OverviewPanelSectionHeader>
          <TriggerTable
            projectTriggersQuery={projectTriggersQuery}
            artifactCollectionTriggersQuery={collectionTriggersQuery}
            actionTypes={['QueueJobTriggeredAction']}
          />
        </div>
      ) : (
        <>
          <S.OverviewPanelSectionHeader>
            <S.OverviewPanelSectionHeaderTitle>
              Automations
            </S.OverviewPanelSectionHeaderTitle>
          </S.OverviewPanelSectionHeader>
          <S.EmptyTriggersTable>
            <S.SettingsOverviewText mainText={true} size="medium">
              No automations yet
            </S.SettingsOverviewText>
            <S.SettingsOverviewText>
              Automate actions based on changes in the registered model.
            </S.SettingsOverviewText>
            <Button
              icon="add-new"
              size="medium"
              variant="primary"
              onClick={() => {
                setAddTriggerModalOpen(true);
                trackCreateTriggerClicked(
                  'Model registry empty trigger table section'
                );
              }}
              style={{marginTop: '8px'}}>
              New automation
            </Button>
          </S.EmptyTriggersTable>
        </>
      )}
      {addTriggerModalOpen && (
        <CreateTriggerModal
          open={addTriggerModalOpen}
          onClose={() => setAddTriggerModalOpen(false)}
          projectName={projectName}
          entityName={entityName}
          projectID={projectID}
          artifactCollectionID={collectionID}
        />
      )}
    </>
  );
};
